import $ from 'jquery';

export default function() {
	//map make good happen list/map toggle
	$('.location-toggle').on('click', function(e) {
		e.preventDefault();
		var id = $(this).attr('data-related');
		$('.view-container').each(function() {
			$(this).hide();
			if ($(this).attr('id') === id) {
				$(this).show();
			}
		});
	});
}



// WEBPACK FOOTER //
// ./src/webpack/widgets/make-good-happen.js